import React, { Component, MouseEvent } from 'react';
import Adapter from './adapter';
import Body from './body';
import Header from './header';
import Sidebar from './sidebar';
import Notification from '../notification';
import { SearchRequest, SearchResponse } from '../../rpc/admin/search_pb';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface SearchProps {
    adapter: Adapter;
    basePath: string;
}

interface SearchState {
    showFilters: boolean;
    loading: boolean;
    request: SearchRequest;
    response: SearchResponse;
    peformedInitialRequest: boolean;
    errorMessage: string;
}

class Search extends Component<SearchProps & RouteComponentProps<any>, SearchState> {

    counter: number = 1;

    constructor(props: SearchProps & RouteComponentProps<any>) {
        super(props);
        this.state = {
            showFilters: false,
            loading: true,
            request: this.props.adapter.searchRequestFromQuery(''),
            response: new SearchResponse(),
            peformedInitialRequest: false,
            errorMessage: ''
        };
    }

    handleShowFilters = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.setState({
            showFilters: true,
        });
    }

    handleHideFilters = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.setState({
            showFilters: false,
        });
    }

    queryChanged = () => {
        this.search();
    }

    componentDidUpdate(prevProps: SearchProps & RouteComponentProps<any>) {
        if (this.props.location !== prevProps.location) {
            this.search();
        }
      }

    componentDidMount() {
        this.props.adapter!.attach(this);
        this.search();
    }

    componentWillUnmount() {
        this.props.adapter!.detach(this);
    }

    private search() {
        const request = this.props.adapter.searchRequestFromQuery(window.location.search.substring(1));

        if (this.state.peformedInitialRequest && JSON.stringify(request) === JSON.stringify(this.state.request)) {
            return;
        }

        this.setState({
            loading: true,
            request: request,
            peformedInitialRequest: true,
        });

        this.props.adapter!.search(request).then((response) => {
            this.setState({
                loading: false,
                response: response,
            });
        }).catch((err) => {
            this.setState({
                errorMessage: err,
            })
            this.setState({
                loading: false,
            });
        });
    }

    render() {
        const notFound = !this.state.response?.getHitsList()?.length && !this.state.loading;
        return (<>
            <div className="columns">
                <div className="column">
                    <Notification className="search-notification" message={this.state.errorMessage} />
                    <Header query={this.state.request!.getQuery()} basePath={this.props.basePath} adapter={this.props.adapter!} />
                </div>
            </div>

            <div className="columns">
                <div className={"column is-hidden-tablet search-sidebar-show" + (this.state.showFilters ? " is-hidden-mobile" : " is-full-mobile")}>
                    <button className="button" onClick={this.handleShowFilters}>Show Filters</button>
                </div>

                <div className={"column is-hidden-tablet search-sidebar-hide" + (this.state.showFilters ? " is-full-mobile" : " is-hidden-mobile")}>
                    <button className="button" onClick={this.handleHideFilters}>Done</button>
                </div>

                <div className={"column is-one-third-tablet search-sidebar" + (this.state.showFilters ? " is-full-mobile" : " is-hidden-mobile")}>
                    <Sidebar response={this.state.response!} request={this.state.request!} adapter={this.props.adapter!}>{this.props.children}</Sidebar>
                </div>

                <div className={"column is-three-thirds-tablet search-body" + (this.state.showFilters ? " is-hidden-mobile" : " is-full-mobile")}>
                    <Body response={this.state.response} request={this.state.request} basePath={this.props.basePath} adapter={this.props.adapter} />
                </div>
            </div>

            {notFound &&
                <div className="columns">
                    <div className="column search-no-results">
                        <div><span role="img" aria-label="Dang">🤔</span> Dang, nothing found!</div>
                    </div>
                </div>
            }
        </>
        );
    }
}

export default withRouter(Search);